module.exports = __webpack_public_path__ + "static/media/bullet_ref.fd8ac370.svg";